import './Notifications.scss'

import { HDSNotification } from '@here/hds-react-components'
import { useAppDispatch, useAppSelector } from 'data/store/hooks'
import React from 'react'

import { NotificationsState, NotificationStateItem } from './data/model'
import { deleteNotification, removeNotificationFromQueue } from './data/reducer'

export const Notifications = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const { notificationsQueue, notification }: NotificationsState = useAppSelector(
    (state) => state.notifications
  )

  return (
    <div className="NotificationsWrapper">
      {notification && (
        <HDSNotification
          inline={notification.inline}
          className="NotificationsWrapper__notification"
          key={notification.id}
          notificationTitle={notification.title}
          duration={notification.duration ?? 5}
          icon={notification.icon}
          iconCategory={notification.iconCategory}
          iconStyle={notification.iconStyle}
          variant={notification.variant}
          onClose={() => dispatch(deleteNotification())}
        >
          {notification.content}
        </HDSNotification>
      )}
      {notificationsQueue.map((notification: NotificationStateItem) => (
        <HDSNotification
          inline={notification.inline}
          className="NotificationsWrapper__notification"
          key={notification.id}
          notificationTitle={notification.title}
          duration={notification.duration ?? 5}
          icon={notification.icon}
          iconCategory={notification.iconCategory}
          iconStyle={notification.iconStyle}
          variant={notification.variant}
          onClose={() => dispatch(removeNotificationFromQueue(notification.id))}
        >
          {notification.content}
        </HDSNotification>
      ))}
    </div>
  )
}
